export enum BandeiraEnum {
    AMERICAN_EXPRESS = '100001',
    DINERS_CLUB = '100005',
    ELO = '100001000',
    HIPERCARD = '100002',
    MASTERCARD = '100003',
    VISA = '100004',
    NULO = '0',
}